import {InitializerService} from '../services/initializer.service';
import {Router} from '@angular/router';

export function appInitializer(router: Router, initializerService: InitializerService): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise(async (resolve) => {
            try {
                await initializerService.initKeycloak();
                await initializerService.initPermissions();
                resolve();
            } catch (error) {
                console.error(error);
                router.navigate(['503']).then();
                resolve(error);
            }
        });
    };
}
